import React from "react";

const PaymentMethodListItem = ({
  method,
  className = "flex justify-start",
  innerClassName = "p-2",
  imageClassName = "inline-block h-8 mr-2",
  showBankName
}) => (
  <div className={className}>
    <div className={innerClassName}>
      {method.logo && (
        <img
          alt="payment-method"
          className={imageClassName}
          src={`data:image/png;base64,${method.logo}`}
        />
      )}
      {!method.logo && method.logoURL && (
        <img
          alt="payment-method"
          className={imageClassName}
          src={`${method.logoURL}`}
        />
      )}
      <div className="text-black capitalize inline-block">
        {showBankName && `${method.institution} - `}
        {method.type}{" "}
        {method.account_number_last_four
          ? `(**${method.account_number_last_four})`
          : ""}
      </div>
    </div>
  </div>
);

export default PaymentMethodListItem;
